const TOPICS = [
  { tag: '#2024热门国剧', heat: '98.6万讨论', active: true },
  { tag: '#院线大片抢先看', heat: '87.3万讨论', active: true },
  { tag: '#高分韩剧推荐', heat: '76.2万讨论', active: false },
  { tag: '#日漫新番速递', heat: '65.8万讨论', active: true },
  { tag: '#悬疑烧脑合集', heat: '54.1万讨论', active: false },
  { tag: '#周末影院盘点', heat: '48.9万讨论', active: false },
  { tag: '#经典港片重温', heat: '43.5万讨论', active: false },
  { tag: '#热门综艺追踪', heat: '39.7万讨论', active: true },
  { tag: '#国产动漫崛起', heat: '35.2万讨论', active: false },
  { tag: '#纪录片推荐', heat: '31.4万讨论', active: false },
  { tag: '#影视配乐原声', heat: '27.8万讨论', active: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-semibold rounded-full mb-4 whitespace-nowrap">
            <i className="ri-fire-line mr-1"></i>热门话题
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            影视圈热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            追踪91影视看片社区最受关注的热议话题和讨论风向
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {TOPICS.map((topic, i) => (
            <a
              key={i}
              href="#topics"
              onClick={(e) => e.preventDefault()}
              className={`group inline-flex items-center gap-2 px-5 py-3 rounded-full border transition-all cursor-pointer whitespace-nowrap ${
                topic.active
                  ? 'bg-primary-500 text-white border-primary-500 hover:bg-primary-600'
                  : 'bg-background-50 text-foreground-700 border-background-200 hover:border-primary-300 hover:text-primary-600'
              }`}
            >
              <span className="text-sm font-medium">{topic.tag}</span>
              <span className={`text-xs ${topic.active ? 'text-white/80' : 'text-foreground-400'}`}>
                {topic.heat}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}